import React, { Component } from 'react'
import { __ } from '../../services/translate'
import SelectPicker from '../../components/Common/SelectPicker'
import calc1 from '../../assets/img/calc/calc1.png'
import calc3 from '../../assets/img/calc/calc3.png'
import calc1table from '../../assets/img/calc/calctable.png'
import { Checkbox } from '../../components/Common/Form'
import Gallery from '../../components/Common/Gallery'
import { Calculator, CalculatorContainer, Information, Result, SelectRow, Smaller } from '../../components/Calc'
import { Card, CardImage, CardText, CardTitle } from '../../components/Common/Card'

export default class Calc1 extends Component {

  constructor(props) {
    super(props)

    this.state = {
      'is': false,
      'number1': 35,
      'number2': 250,
      'number3': 1,
    }
  }

  toggle = () => this.setState({ is: !this.state.is })

  getResult = () => {
    const { number1, number2, number3, is } = this.state
    return __(this.props.data[number1][number2][is ? '0.6' : '0.3-0.4'][number3])
  }

  render() {
    return (
      <CalculatorContainer>
        <Calculator>
          <Card>
            <CardTitle>{__('Metoda třecího přivázání')}</CardTitle>
            <CardImage src={calc1} alt=""/>
            <CardText>
              <label>
                <Checkbox
                  type="checkbox"
                  checked={this.state.is}
                  onChange={this.toggle}
                />
                {__('Protiskluzová podložka (min µ=0,6)')}
              </label>
              <div>{__('Součinitel tření')}: {this.state.is ? '0.6' : '0.3 - 0.4'} µ</div>
            </CardText>
          </Card>
          <Card>
            <SelectRow>
              <span>{__('Upínací úhel')}:</span>
              <SelectPicker
                selected={this.state.number1}
                onSelect={(item) => this.setState({ number1: item.value })}
                renderOption={(item) => `${item.value}°`}
                options={Object.keys(this.props.data).map(item => ({ id: Number(item), value: Number(item) }))}
              />
            </SelectRow>
            <SelectRow>
              <span>{__('Napínací sila')} (S<Smaller>TF</Smaller>):</span>
              <SelectPicker
                selected={this.state.number2}
                onSelect={(item) => this.setState({ number2: item.value })}
                renderOption={(item) => `${item.value}daN`}
                options={Object.keys(this.props.data[35]).map(item => ({ id: Number(item), value: Number(item) }))}
              />
            </SelectRow>
            <SelectRow>
              <span>{__('Hmotnost nákladu')}:</span>
              <SelectPicker
                selected={this.state.number3}
                onSelect={(item) => this.setState({ number3: item.value })}
                renderOption={(item) => `${item.value}t`}
                options={Object.keys(this.props.data[35][250]['0.3-0.4']).map(item => ({
                  id: Number(item),
                  value: Number(item)
                }))}
              />
            </SelectRow>
          </Card>
          <Card>
            <CardTitle>{__('Nutný min. počet přivazovaních popruhu')}</CardTitle>
            <CardText>
              {__('Výpočet')}:
              <Result>{this.getResult()}</Result>
            </CardText>
          </Card>
        </Calculator>
        <Information>
          <Card>
            <CardTitle>{__('Součinitel tření')} µ</CardTitle>
            <CardText>{__('Vztah dvou materiálů dle tabulky. Je dobré vyvarovat se znečištení či použíť protiskluzovou podložku.')}</CardText>
            {/*<CardImage src={calc1table} alt=""/>*/}
            <Gallery images={[calc1table]}/>
          </Card>

          <Card>
            <CardTitle>
              {__('Normalizovaná napínací sila')}
              <span>(S<Smaller>TF</Smaller>)</span>
            </CardTitle>
            <CardText>
              {__('Musí být min. 10% LC, max však 50% LC. Kontroluje se přistrojem na měření sily (tenzometr). Vždy uvažujeme horší variantu.')}
            </CardText>
          </Card>

          <Card>
            <CardTitle>{__('Úhel')} α</CardTitle>
            <CardText>
              {__('Úhel svíraný mezi upínacím prostředkem a podlahou ložné plochy (horizontální). V rozmezi 35° - 90°.')}
            </CardText>
            <CardImage src={calc3} alt=""/>
          </Card>
        </Information>
      </CalculatorContainer>
    )
  }
}
